import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-tatva',
  templateUrl: './about-tatva.component.html',
  styleUrls: ['./about-tatva.component.css']
})
export class AboutTatvaComponent implements OnInit {
  
  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
  }
  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }

}
